import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;
const TRADES = ['HVAC', 'Plumbing', 'Electrical', 'Multiple Trades'];

export default function ComingSoon() {
  const [form, setForm] = useState({ first_name: '', email: '', company_name: '', trade: '' });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    if (!form.first_name.trim() || !form.email.trim() || !form.company_name.trim() || !form.trade) {
      setError('Please fill in every field.');
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      const res = await fetch(`${API}/api/public/early-access`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Something went wrong. Try again.');
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls =
    'w-full rounded-lg bg-white/[0.04] border border-white/15 px-4 py-3 text-white placeholder-[#5c6a7a] text-sm focus:outline-none focus:border-[#c6f24e] transition-colors';

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#07090c' }} data-testid="coming-soon-page">
      {/* subtle glow */}
      <div aria-hidden="true" className="pointer-events-none fixed inset-0"
        style={{ background: 'radial-gradient(ellipse 60% 40% at 50% -10%, rgba(198,242,78,0.08), transparent 70%)' }} />

      <main className="relative flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-xl text-center">
          <img src="/gritclicks-logo.png" alt="GritClicks" className="h-28 sm:h-32 w-auto mx-auto mb-10" style={{ transform: 'translateX(-16.8%)' }} data-testid="coming-soon-logo" />

          <p className="text-[11px] font-bold tracking-[0.35em] uppercase mb-6" style={{ color: '#c6f24e' }} data-testid="coming-soon-eyebrow">
            Coming Soon
          </p>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight mb-5" data-testid="coming-soon-headline">
            GRITCLICKS
          </h1>

          <p className="text-lg text-[#c9d3de] mb-3" data-testid="coming-soon-tagline">
            Marketing built for contractors who would rather do it themselves.
          </p>
          <p className="text-sm text-[#8494a5] mb-1">Campaigns. Ads. Content. Strategy.</p>
          <p className="text-sm text-[#8494a5] mb-1">Built for HVAC, Plumbing &amp; Electrical contractors.</p>
          <p className="text-sm text-[#8494a5] mb-10">We're building something different.</p>

          {done ? (
            <div className="rounded-xl border border-[#c6f24e]/40 px-6 py-8" style={{ backgroundColor: 'rgba(198,242,78,0.06)' }} data-testid="early-access-success">
              <p className="text-white font-bold text-lg">You're on the list.</p>
              <p className="text-[#c9d3de] text-sm mt-1">We'll let you know when GritClicks opens.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="text-left" data-testid="early-access-form" noValidate>
              <div className="grid gap-3 sm:grid-cols-2">
                <input value={form.first_name} onChange={set('first_name')} placeholder="First Name" aria-label="First Name"
                  className={inputCls} data-testid="early-access-first-name" />
                <input type="email" value={form.email} onChange={set('email')} placeholder="Email" aria-label="Email"
                  className={inputCls} data-testid="early-access-email" />
                <input value={form.company_name} onChange={set('company_name')} placeholder="Company Name" aria-label="Company Name"
                  className={inputCls} data-testid="early-access-company" />
                <select value={form.trade} onChange={set('trade')} aria-label="Trade"
                  className={`${inputCls} ${form.trade ? 'text-white' : 'text-[#5c6a7a]'}`} data-testid="early-access-trade">
                  <option value="" disabled>Trade</option>
                  {TRADES.map((t) => <option key={t} value={t} className="text-black">{t}</option>)}
                </select>
              </div>
              {error && <p role="alert" className="mt-3 text-sm font-semibold" style={{ color: '#f87171' }} data-testid="early-access-error">{error}</p>}
              <button type="submit" disabled={submitting} data-testid="early-access-submit"
                className="mt-4 w-full rounded-lg py-3.5 font-extrabold text-[15px] tracking-wide transition-colors disabled:opacity-50"
                style={{ backgroundColor: '#c6f24e', color: '#07090c' }}>
                {submitting ? 'Joining…' : 'JOIN EARLY ACCESS'}
              </button>
            </form>
          )}

          <p className="text-[13px] text-[#8494a5] mt-8 leading-relaxed">
            No agency retainers. No handing over your marketing.<br />
            GritClicks gives contractors the campaigns, tools and guidance to run smarter marketing themselves.
          </p>
        </div>
      </main>

      <footer className="relative py-6 text-center">
        <Link to="/login" className="text-[12px] text-[#5c6a7a] hover:text-[#c9d3de] transition-colors" data-testid="coming-soon-login-link">
          Member login
        </Link>
      </footer>
    </div>
  );
}
